import React from "react";
import logo from "./logo.svg";
import colors from "./style.module.scss";

import "./App.css";
import UnAuthLayout from "./layout/UnAuthLayout";
import { Route, useNavigate } from "react-router";
import { Routes } from "react-router";
import AuthLayout from "./layout/AuthLayout";
import LivePlatformPage from "./pages/MainChatPlatformPage/MainChatPlatformPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import LiveProductionPage from "./pages/LiveProductionPage/LiveProductionPage";
import MainChatPlatformPage from "./pages/MainChatPlatformPage/MainChatPlatformPage";
import { initializeIcons } from "@fluentui/react";
import { Provider } from "react-redux";
import store from "./redux/store";
import { Amplify } from "aws-amplify";
import APP_CONFIG from "./configs/environment";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import { ConfigProvider } from "antd";
initializeIcons();
Amplify.configure(APP_CONFIG.amplify_config);

function App() {
  const navigate = useNavigate();
  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: { colorPrimary: colors.colorPrimary },
        }}>
        <Routes>
          <Route
            path="/"
            element={<UnAuthLayout />}>
            {/* Todo: Add login page here */}
            <Route
              path=""
              element={<LoginPage />}
            />
          </Route>

          <Route
            path="chat"
            element={<AuthLayout />}>
            <Route
              path=""
              element={<MainChatPlatformPage />}
            />
            <Route
              path="live"
              element={<LiveProductionPage />}
            />
          </Route>
          <Route
            path="no-access"
            element={
              <ErrorPage
                errorMessage="401 - Unauthorized Access."
                errorDescription="We're sorry, but you're not authorized to view this content. For assistance, please contact our administrators."
                actionBtn={
                  <button
                    className="button"
                    onClick={() => navigate("/")}>
                    Return
                  </button>
                }
              />
            }
          />
          <Route
            path="*"
            element={
              <ErrorPage
                errorMessage="404 - Page Not Found."
                errorDescription="The page you're looking for might have been moved, deleted, or it could be temporarily unavailable."
                actionBtn={
                  <button
                    className="button"
                    onClick={() => navigate("/chat")}>
                    Return
                  </button>
                }
              />
            }
          />
        </Routes>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
